export const environment = {
  appName: 'merchantPortal',
  appVersion: process.env['NG_APP_VERSION'],
  backend_portal_url: 'https://api-stg.pivot-payment.com/backend-portal/',
  mock_portal_url: 'https://0c6f5f0a-945e-4179-bc3c-d75294286cc6.mock.pstmn.io/',
  bucket_url: 'pg-staging-bulk-disbursement',
  staticBucketUrl: 'pg-staging-static-files',
  wallet_backend_url: 'https://api-stg.pivot-payment.com/wallet-backend',
  send_new_relic: true,
  helpdesk_email: 'helpdesk@pivot-payment.com',
  vcc_merchant_whitelist_skip_luhn_validation: ['7569e1bf-856e-4fb2-a1c2-3a3f7c0145cb'],
  flag: {
    is_development: true,
    show_dashboard: false,
    show_help_center: false,
    show_notfication: false,
    show_my_business: false,
    show_developer_setting: true,
    use_custom_acl: true,
    use_xb_payout: true,
    show_coming_soon_banner: false,
    show_dashboard_tutorial_banner: true,
    show_tnc: true,
  },
  new_relic: {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },
    loader_config: {
      accountID: '3594198',
      trustKey: '3594198',
      agentID: '1386169702',
      licenseKey: process.env['NG_APP_NEW_RELIC_LICENSE_KEY'] || '',
      applicationID: '1386169702',
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: process.env['NG_APP_NEW_RELIC_LICENSE_KEY'] || '',
      applicationID: '1386169702',
      sa: 1,
    },
  },
  stomp: {
    brokerURL: 'wss://rabbitmq-pg-stg.pivot-payment.com/ws',
    login: 'merchant_portal',
    passcode: process.env['NG_APP_STOMP_PASSCODE'] || '',
  },
  sharedSecretKey: process.env['NG_APP_SHARED_SECRET_KEY'] || '',
  vccSharedStaticKey: process.env['NG_APP_VCC_SHARED_STATIC_KEY'] || '',
  topUpSimulation: true,
  enableMock: false,
  fingerprintJs: {
    apiKey: 'SaRVVPai96VRY6sr9C8H',
    region: 'ap',
  },
  turnstile: {
    siteKey: '0x4AAAAAAFLwWEfYDgOehstw',
    widget: 'invisible',
  },
  feature_flag_host: 'https://feature-flag.stag-v2.paper.id',
  isOldLogo: false,
  clarity: {
    projectId: 'rx7wuzzlej',
  },
  googleTagManager: {
    id: 'GTM-PZGRCP2R',
  },
  trustedImageDomains: ['storage.googleapis.com', 'storage.cloud.google.com'],
  paymentUiOrigins: ['https://pay-stg.pivot-payment.com', 'http://localhost:4200'],
};
